<script lang="ts">
	import logoIntimexWhite from "@assets/images/logo-intimex-white.svg";
	import ContactForm from "@components/ContactForm.svelte";
	import Formatted from "@components/common/Formatted.svelte";
	import Link from "@components/common/Link.svelte";
	import Media from "@components/common/Media.svelte";
	import { contactEmail } from "@core/schema/contact.js";
</script>

<section class="grid-container full-width bg-gradient-to-t from-light/50 to-light pt-10 pb-12 lg:py-24">
	<div class="flex flex-col lg:flex-row justify-center gap-6" id="contact-form">
		<h3 class="text-blue lg:w-[28.5rem] font-medium">
			<Formatted text="clb[[Hledáte dodavatele diagnostických reagencií?]] nl[[]]Kontaktujte nás ještě dnes" />
		</h3>
		<ContactForm />
	</div>
</section>

<footer class="grid-container bg-black text-white pt-12 lg:pt-28">
	<div class="pb-10 lg:pb-28 grid lg:grid-cols-2">
		<Media
			width={262.26}
			height={65}
			alt="Intimex logo"
			source={{ src: logoIntimexWhite, type: "image/svg+xml" }}
			class="mx-auto mb-8 "
		></Media>
		<div class="flex flex-col lg:flex-row gap-6">
			<div class="lg:w-[16.5rem]">
				<span class="text-xs text-lightblue uppercase tracking-widest font-semibold"
					><Formatted text="Viděli jste?" /></span
				>
				<ul class="mt-4 lg:mt-10">
					<li>
						<Link href="#" class="leading-10 underline text-light">
							<Formatted text="Produkty" />
						</Link>
					</li>
					<li>
						<Link href="#" class="leading-10 underline text-light">
							<Formatted text="Vyhledávání dle chromozomů" />
						</Link>
					</li>
					<li>
						<Link href="#" class="leading-10 underline text-light">
							<Formatted text="Poptat spolupráci" />
						</Link>
					</li>
				</ul>
				<ul class="mt-2 lg:mt-10">
					<li>
						<Link href="#" class="leading-10 underline text-light">
							<Formatted text="Kontakty" />
						</Link>
					</li>
					<li>
						<Link href="#" class="leading-10 underline text-light">
							<Formatted text="Ochrana osobních údajů" />
						</Link>
					</li>
				</ul>
			</div>
			<div>
				<span class="text-xs text-lightblue uppercase tracking-widest font-semibold"
					><Formatted text="Rychlý kontakt" /></span
				>
				<p class="text-light leading-6 mt-4 lg:mt-10">
					<Formatted text="INTIMEX s.r.o. nl[[]]Vrchlického sady 541/6 nl[[]]735 06 Karviná – Nové Město" />
				</p>
				<p class="text-light leading-6 mt-6">
					<Formatted text="+420 596 311 612 nl[[]]{contactEmail}" />
				</p>
				<p class="text-light leading-6 mt-6">
					<Formatted text="IČ 25908375 nl[[]]DIČ CZ25908375" />
				</p>
			</div>
		</div>
	</div>
	<div class="full-width py-4 bg-blue text-center text-lightblue text-xs leading-3">&copy; Nyro 2025</div>
</footer>
